import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { UserService } from 'src/app/services/user.service';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-model',
  templateUrl: './model.component.html'
})
export class ModelComponent implements OnInit {

  models: any;

  @Output() onComplete: EventEmitter<void> = new EventEmitter();
  
  constructor(public current: CurrentService, public datas: DatasService, public user: UserService, private gtm: GTM) { }

  async ngOnInit(): Promise<void> {
    this.gtm.trackPage(CONTEXT.KITCHEN, 'need-mapping', 'model', this.datas.getKitchenGtmData(this.current));
    let data = await this.datas.getModels();
    if (this.current.styleId > 0) {
      this.models = data.filter((m: any) => {
        if (!m.active) return false;
        return m.styleId === this.current.styleId
      });
    } else {
      this.models = data.filter(m => m.active);
    }
  }

  selectModel(modelId: number) {
    this.gtm.trackEvent('click', 'need-mapping', 'model-' + modelId);
    this.current.modelId = modelId;
    this.onComplete.emit();
  }
}
